"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AnalyticsWrapper = _ref => {
  let {
    analytics
  } = _ref;
  (0, _react.useEffect)(() => {
    // Load analytics script
    const loadAnalyticsScript = () => {
      const script = document.createElement('script');
      script.src = analytics;
      script.async = true;
      script.id = 'analytics-script';

      // Only add the script if it hasn't been added yet
      if (!document.getElementById('analytics-script')) {
        document.head.appendChild(script);
      }
    };
    if (analytics) {
      loadAnalyticsScript();
    }

    // Cleanup function
    return () => {
      const script = document.getElementById('analytics-script');
      if (script) {
        script.remove();
      }
    };
  }, [analytics]);
  return null;
};
var _default = exports.default = AnalyticsWrapper;